import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

import ShareButtons from "./ShareButtons";
import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";
import RichTextBlock from "./RichTextBlock";

const PressRelease = ({ pressRelease }) => (
    <div className="press-release">
        <h1 className="title">{pressRelease.title}</h1>

        <time
            dateTime={moment(pressRelease.publishDate).format("MMMM D, YYYY")}
            itemProp="datePublished"
            content={moment(pressRelease.publishDate).format(
                "YYYY-MM-DDThh:mm:ss.sTZD"
            )}
            className="publish-date"
        >
            {moment(pressRelease.publishDate).format("MMMM D, YYYY")}
        </time>

        <ShareButtons className="my-2" />

        {pressRelease.image && !pressRelease.hideImageOnFullPage && (
            <GatsbyImageWithSVGSupport
                image={pressRelease.image}
                className="image w-100"
            />
        )}

        <div className="body">
            <RichTextBlock content={pressRelease.body} />
        </div>
    </div>
);

PressRelease.propTypes = {
    pressRelease: PropTypes.shape({
        title: PropTypes.string.isRequired,
        publishDate: PropTypes.string.isRequired,
        hideImageOnFullPage: PropTypes.bool,
        image: PropTypes.shape({ gatsbyImageData: PropTypes.object }),
        body: PropTypes.shape({ raw: PropTypes.string.isRequired }).isRequired,
    }),
};

export default PressRelease;
